
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/skireport",
      function () {
        return require("private-next-pages/skireport.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/skireport"])
      });
    }
  